module.exports = "/assets/415f22392331a7eeab91d128cc351f2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SD.png
// module id = 1817
// module chunks = 0